import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgHourglass = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="#96979A"
        d="M41.75 21.82v-5.57a2.5 2.5 0 0 0-2.5-2.5h-17.5a2.5 2.5 0 0 0-2.5 2.5v5.63a2.51 2.51 0 0 0 1 2L28.42 30l-8.17 6.13a2.51 2.51 0 0 0-1 2v5.62a2.5 2.5 0 0 0 2.5 2.5h17.5a2.5 2.5 0 0 0 2.5-2.5v-5.57a2.51 2.51 0 0 0-1-2L32.58 30l8.19-6.19a2.5 2.5 0 0 0 .99-2Zm-3.4 15.68H22.58l7.92-5.94zm-16.6 6.25V40h17.5v3.75zm17.5-21.93-8.75 6.62-8.75-6.57v-5.62h17.5z"
      />
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgHourglass);
export default Memo;
